class EventBus {
  private subscriptions: Record<string, Set<any>> = {};

  publish = (eventName: string, ...args: any) => {
    if (!this.subscriptions[eventName]) {
      return;
    }

    const callbacks = this.subscriptions[eventName];

    for (const callback of callbacks) {
      callback(...args);
    }
  };

  subscribe = <T extends Record<string, unknown>>(eventName: string, callback: (data?: T) => void) => {
    if (!this.subscriptions[eventName]) {
      this.subscriptions[eventName] = new Set();
    }

    const callbacks = this.subscriptions[eventName];
    callbacks.add(callback);

    return () => {
      callbacks.delete(callback);

      if (callbacks.size === 0) {
        delete this.subscriptions[eventName];
      }
    };
  };
}

export const eventBus = new EventBus();
